import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'services/redux/configureStore';

export const selectUnviewedCommentsCount = createSelector(
  (state: RootState) => state.tasksBoard.newComments.comments,
  (comments) => comments.filter((comment) => comment.isViewed === false).length
);
